import React, { forwardRef, useRef, useMemo } from 'react';
import { LoadingOverlay, ScrollArea } from '@mantine/core';
import styles from './index.modules.scss';
import HistoryItem from '../HistoryItem';
import { Empty, Bottom } from '@shakkerai/pro-components';
import { NewMessageTip } from '../NewMessageTip';
import { useMessageTipHooks } from '../../hooks/eventHooks';
import { EVENT_LABEL_INIT_RESORT } from '../../utils/eventbus';
import { eventBus } from '@starflow/app/helpers';

/**
 * 用于渲染全部历史和专辑详情
 */
export const HistoryList = forwardRef((props, ref) => {
  const {
    searchValueRef,
    scrollContainerRef,
    noSearchStr,
    noDateStr,
    source, // source用于进入图片详情页根据不同的source对图片是否收藏的聚合做分类
    deleteRefreshLabel, // 图片删除后根据deleteRefreshLabel区分是历史记录删除还是专辑详情的删除
    newRecordEventLabel, // 用于在有新数据时接收新消息提醒的标识
    data,
    loading,
    loadingMore,
    noMore,
    reload,
  } = props;
  const scrollWrapperRef = useRef(null);

  const isEmpty = useMemo(() => {
    if (data?.list.length === 0) {
      return true;
    } else {
      // 本地将数据全删了的情况
      const notEmpty = data?.list.some((item) => !item.deleted);
      return !notEmpty;
    }
  }, [data]);

  const { showUpdateTips, newRecordCount, closeTip } = useMessageTipHooks(
    scrollContainerRef,
    newRecordEventLabel,
    () => {
      // 不超半屏时可自动刷新
      eventBus.emit(EVENT_LABEL_INIT_RESORT);
      reload();
    },
  );

  return (
    <div ref={ref} className="relative h-full">
      <div className={`${styles.scrollC}`}>
        {loading ? (
          <LoadingOverlay visible={loading} zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />
        ) : !isEmpty ? (
          <ScrollArea viewportRef={scrollContainerRef} scrollbarSize={4}>
            <div ref={scrollWrapperRef} className={styles.inner} data-his-c>
              {data?.list.map((item) =>
                item.deleted ? null : (
                  <HistoryItem
                    key={item.generateId}
                    deleteFreshLabel={deleteRefreshLabel}
                    itemInfo={item}
                    source={source}
                  />
                ),
              )}
              <div>
                <Bottom
                  loadingMore={loadingMore}
                  noMore={noMore}
                  className="pl-[170px] pr-[170px] pt-[17px] pb-[34px]"
                ></Bottom>
              </div>
            </div>
          </ScrollArea>
        ) : (
          <div className={styles.emptyC}>
            <Empty content={searchValueRef.current ? noSearchStr : noDateStr} />
          </div>
        )}
      </div>

      {showUpdateTips && (
        <NewMessageTip
          newRecordCount={newRecordCount}
          onRefresh={() => {
            eventBus.emit(EVENT_LABEL_INIT_RESORT);
            reload();
            closeTip();
          }}
          onClose={closeTip}
        />
      )}
    </div>
  );
});
